import {
	Box,
	Paper,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	TableRow,
	TableCell,
	Typography,
	List,
	ListItem,
	ListItemText
} from '@mui/material';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EntryItem from './EntryItem';

const TABLE_HEADERS = [
	{
		value: 'first_name',
		label: 'First Name',
		sortable: false,
		hidden: false
	},
	{
		value: 'last_name',
		label: 'Last Name',
		sortable: false,
		hidden: false
	},
	{
		value: 'country',
		label: 'Country',
		sortable: false,
		hidden: false
	},
	{
		value: 'age',
		label: 'Age',
		sortable: false,
		hidden: false
	}
];

const EventUserList = ({ event }) => {
	const navigate = useNavigate();
	const { id, event_submissions } = event;

	const handleClick = (submission) => {
		navigate(`/events/${id}/entries/${submission.id}`);
	};

	return (
		<Box>
			{event_submissions?.length > 0 ? (
				<TableContainer component={Paper} elevation={0}>
					<Table>
						<TableHead>
							<TableRow>
								{TABLE_HEADERS.filter((h) => !h.hidden).map((header, idx) => (
									<TableCell key={idx}>
										<Typography variant="subtitle2" color="text.secondary">
											{header.label}
										</Typography>
									</TableCell>
								))}
								<TableCell align="right" />
							</TableRow>
						</TableHead>
						<TableBody>
							{event_submissions.map((submission, idx) => (
								<EntryItem
									key={idx}
									entry={submission}
									isSelectable={false}
									handleClick={handleClick}
								/>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			) : (
				<List>
					<ListItem>
						<ListItemText
							secondary="No users have applied yet."
							secondaryTypographyProps={{ color: 'text.secondary' }}
						/>
					</ListItem>
				</List>
			)}
		</Box>
	);
};

export default EventUserList;
